export class Select {
  constructor(
    public displayExpr: string = "",
    public displayExprExport: string = "",
    public valueExpr: string = "") {
    }
}
